export class AudienceLineDTO {
  audienceId: number;

  audienceLineId: number;

  userId?: string;

  groupId?: string;

  roleId?: string;

  constructor() {
    this.audienceId = 0;
    this.audienceLineId = 0;
  }
}
